import { SurgicalStatusModel } from 'domain/entities/surgical-status-model'
import { SurgicalOrderStatus } from 'presentation/shared/components/Timeline/status'

export function getCrmoTableStatus(surgeryStatusEnum: SurgicalStatusModel[]) {
  let actualStatus = surgeryStatusEnum.slice(-1)[0].status
  if (actualStatus === SurgicalOrderStatus.SCHEDULED) {
    actualStatus = surgeryStatusEnum.slice(-2)[0].status
  }
  const crmoStatus = {
    [SurgicalOrderStatus.ORDER_REGISTERED]: 'Pedidos solicitados por pacientes',
    [SurgicalOrderStatus.REVIEW]: 'Revisão',
    [SurgicalOrderStatus.OPME_QUOTATION]: 'Cotação de OPME',
    [SurgicalOrderStatus.PRE_SCHEDULE]: 'Pré agendamento',
    [SurgicalOrderStatus.CRMO]: 'Na CRMO',
    [SurgicalOrderStatus.HEALTH_INSURANCE_APPROVE]: 'No Convênio',
    [SurgicalOrderStatus.AUTHORIZED]: 'Autorizado',
    [SurgicalOrderStatus.FASTPASS]: 'Autorizado',
    [SurgicalOrderStatus.CHECK_IN]: 'Autorizado',
    [SurgicalOrderStatus.PATIENT_IN_SURGERY]: 'Autorizado',
    [SurgicalOrderStatus.PATIENT_RECOVERY]: 'Autorizado',
    [SurgicalOrderStatus.PATIENT_DISCHARGE]: 'Autorizado',
    [SurgicalOrderStatus.CONCLUDED]: 'Realizada',
    [SurgicalOrderStatus.CANCELLATION_REQUEST]: 'Solicitação de cancelamento',
    [SurgicalOrderStatus.SERVICE_EVALUATION]: 'Realizada',
    [SurgicalOrderStatus.CANCELLED]: 'Cancelada',
    [SurgicalOrderStatus.PENDENCY]: 'Pendências',
    [SurgicalOrderStatus.SCHEDULED]: 'Pedido agendado',
    [SurgicalOrderStatus.UNSCHEDULED]: 'Pedido não agendado',
    [SurgicalOrderStatus.CRMO_VALIDATION]: 'Validação CRMO',
    [SurgicalOrderStatus.IN_HEALTH_INSURANCE]: 'Aguardando retorno do convênio',
    [SurgicalOrderStatus.SCHEDULED_AUTHORIZED]: 'Pedidos agendados autorizados',
    [SurgicalOrderStatus.SCHEDULED_NOT_AUTHORIZED]:
      'Pedidos agendados não autorizados',
    [SurgicalOrderStatus.UNSCHEDULED_AUTHORIZED]:
      'Pedidos não agendados autorizados',
    [SurgicalOrderStatus.UNSCHEDULED_NOT_AUTHORIZED]:
      'Pedidos não agendados não autorizados',
    [SurgicalOrderStatus.PARTIALLY_AUTHORIZED]: 'Autorizado com divergência',
    [SurgicalOrderStatus.DENIED]: 'Negado',
    [SurgicalOrderStatus.IN_AUTHORIZATION_PROCESS]:
      'Pedidos em processo de autorização',
    [SurgicalOrderStatus.REANALYSIS]: 'Reanálise'
  }
  return crmoStatus[actualStatus]
}
